import { GoogleSearchScreenshotsState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';
import {
  IGoogleSearchState,
  IGoogleSearchVerificationHistory,
} from '@/interfaces/google-search';


export const mutations = {
  setGoogleSearchFinished(state: GoogleSearchScreenshotsState, payload: boolean) {
    state.finished = payload;
  },
  setGoogleSearchState(state: GoogleSearchScreenshotsState, payload: IGoogleSearchState) {
    state.state = payload;
  },
  setGoogleSearchVerificationHistory(
    state: GoogleSearchScreenshotsState,
    payload: IGoogleSearchVerificationHistory,
  ) {
    state.verificationHistory = payload.items;
    state.verificationHistoryTotal = payload.total;
  },
};

const { commit } = getStoreAccessors<GoogleSearchScreenshotsState, State>('');

export const commitSetGoogleSearchFinished = commit(mutations.setGoogleSearchFinished);
export const commitSetGoogleSearchState = commit(mutations.setGoogleSearchState);
export const commitSetGoogleSearchVerificationHistory = commit(
  mutations.setGoogleSearchVerificationHistory,
);
